<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
import api from "./public/api.js"
import md5 from "./public/md5.js"
export default {
	data() {
		return {

		}
	},
	created() {
		if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
			// console.log("是iOS客户端");
			this.$store.commit('setShebei', 'iOS')
		} else if (/Android/i.test(navigator.userAgent)) {
			// console.log("是Android客户端");
			this.$store.commit('setShebei', 'Android')
		} else {
			// console.log("是PC浏览器");
			this.$store.commit('setShebei', 'PC')
		}

	},
	methods: {}
}
</script>

<style>
.clue {
	color: #a7a7a7;
	margin-left: 20px;
}

.clue>span {
	font-weight: bold;
}

* {
	margin: 0;
	padding: 0;
}

li {
	list-style: none;
}


::-webkit-scrollbar {
	display: none;
}

.pointer:hover {
	cursor: pointer;
	color: #00aaff !important;
}
</style>
